import { render, staticRenderFns } from "./MyUpload.vue?vue&type=template&id=06dac312&scoped=true&"
import script from "./MyUpload.vue?vue&type=script&lang=js&"
export * from "./MyUpload.vue?vue&type=script&lang=js&"
import style0 from "./MyUpload.vue?vue&type=style&index=0&id=06dac312&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06dac312",
  null
  
)

export default component.exports